import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { apiFetch, setToken, setStoredUser, getToken } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getToken()) navigate("/admin/overview");
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await apiFetch("/auth/login", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      });
      setToken(data.access_token);
      setStoredUser(data.user);
      navigate("/admin/overview");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-ink px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-warmwhite/15 bg-charcoal p-10" data-testid="admin-login-form">
        <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-amber">iINSPIRE Cockpit</p>
        <h1 className="mt-4 font-serif text-3xl text-warmwhite">Welcome back.</h1>
        <label className="mt-8 block">
          <span className="mb-2 block text-[10px] font-semibold uppercase tracking-[0.25em] text-warmwhite/60">Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-email-input"
            className="w-full border border-warmwhite/20 bg-ink px-4 py-3 text-sm text-warmwhite outline-none focus:border-amber"
          />
        </label>
        <label className="mt-5 block">
          <span className="mb-2 block text-[10px] font-semibold uppercase tracking-[0.25em] text-warmwhite/60">Password</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password-input"
            className="w-full border border-warmwhite/20 bg-ink px-4 py-3 text-sm text-warmwhite outline-none focus:border-amber"
          />
        </label>
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          className="mt-8 inline-flex w-full items-center justify-center gap-3 bg-amber px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-warmwhite disabled:opacity-60"
          data-testid="admin-login-submit"
        >
          {loading ? "Signing in…" : "Sign In"} <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
        </button>
      </form>
    </main>
  );
}
